export default {
    about_the_course: "Sobre el curso",
    activity_plural: "Actividades",
    activity: "Actividad",
    block_general_test: "Prueba general de Bloqueo",
    block_test: "Prueba tipo 'Bloqueo'",
    blocked: "Bloqueado",
    class_plural: "Lecciones",
    class: "Lección",
    classes: "Lecciones",
    comment: "Comentario",
    congratulations: "¡Felicidades!",
    continue: "En progreso",
    conventional_test: "Prueba tipo 'Convencional'",
    discussions_about_this_course: "Discusiones sobre este curso",
    doubts: "¿Dudas?",
    end_quiz: "Finalizar cuestionario",
    enroll: "Inscribirse",
    enrolled: "Registrado",
    enrollement_type: "Tipo de matrícula",
    evaluated_quiz: "Quiz con evaluación",
    finish_test: "Terminar",
    flash: "Flash",
    html: "HTML",
    if_you_are_not_approved_within_the_available_attempts_you_will_have_your_progress_restarted: "Si no está aprobado dentro de los intentos disponibles, se reiniciará su progreso.",
    if_you_fail_the_available_attempts_you_will_be_blocked_in_this_training: "Si fallas los intentos disponibles, serás bloqueado en este entrenamiento.",
    if_you_pass_you_can_use_the_remaining_attempts_to_try_to_improve_your_grade: "Si aprueba, puede usar los intentos restantes para tratar de mejorar su calificación.",
    improved: "Mejorado",
    in_this_course: "en este curso",
    keep_trying: "Continúa intentando.",
    loading_courses: "Cargando cursos",
    mandatory: "Obligatorio",
    maximum_attempts: "Intentos máximos",
    minimum_to_pass: "Mínimo para pasar",
    next_question: "Próxima",
    previous_question: "Anterior",
    no_courses_are_available_at_the_moment: "Actualmente no hay cursos disponibles",
    no_courses_are_available_with_the_selected_filter: "No hay cursos disponibles para el filtro seleccionado",
    not_started: "No empezado",
    number_of_questions: "Numero de preguntas",
    of_attempts: "{qty_attempted} de {maximum_attempts} intentos",
    of_questions: "{minimum_score} de {qty_questions} preguntas",
    once_you_start_the_test_you_should_not_change_activity_leave_or_refresh_the_page: "Al comenzar la prueba, no debe cambiar su actividad, abandonar o actualizar la página.",
    one_attempt: "Un intento",
    overview: "Tablero",
    powerpoint: "PowerPoint",
    presentation: "Presentación",
    previous_results: "Resultados anteriores",
    question_plural: "Preguntas",
    question: "Pregunta",
    reproved: "Reprobado",
    restart_general_test: "Prueba general de Reset",
    restart_test: "Prueba tipo 'Reset'",
    restart_training: "Reiniciar entrenamiento",
    restarted: "Reiniciado",
    scorm: "Actividade",
    see_previous_results: "Ver resultados anteriores",
    see_results: "Ver resultados",
    see_answers: "Ver respuestas",
    slideshare: "Slideshare",
    start_quiz: "Comenzar cuestionario",
    start_test: "Iniciar prueba",
    start: "Iniciar",
    support_material_preview: "Vista previa del material de soporte",
    support_materials: "Material de Soporte",
    test_performance: "Rendimiento en prueba",
    thank_you_for_taking_the_quiz: "Gracias por responder el cuestionario.",
    that_was_close: "¡Fue cerca!",
    the_result_of_this_quiz_will_not_influence_the_final_result_of_your_training: "El resultado de este cuestionario no influirá en el resultado final de su entrenamiento.",
    time_left: "Tiempo restante",
    time_to_finish: "Hora de terminar",
    unenroll: "Cancelar inscripción",
    unevaluated_quiz: "Quiz sin evaluación",
    unlimited: "Ilimitada",
    until_approval: "Hasta aprobación",
    video: "Video",
    view_history: "ver historial",
    when_starting_the_quiz_you_should_not_change_your_activity_leave_or_update_the_page: "Al comenzar el cuestionario, no debe cambiar su actividad, abandonar o actualizar la página.",
    you_are_allowed_to_take_this_test_how_many_times_you_like_until_you_reach_the_minimum_score_to_pass: "Puede realizar esta prueba tantas veces como desee hasta que alcance el puntaje mínimo para aprobar.",
    you_can_take_this_quiz_as_many_times_as_needed_and_you_will_need_to_get_out_of_questions_to_pass: "Puede realizar este cuestionario tantas veces como sea necesario y deberá obtener {minimum_score} de {qty_questions} preguntas para pasar.",
    you_can_take_this_quiz_only_once_to_answer_as_many_questions_as_possible: "Puede responder este cuestionario solo una vez para responder tantas preguntas como sea posible.",
    you_can_take_this_test_only_once_with_a_timeout_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test: "Puede responder esta prueba solo una vez con el tiempo de espera {time_to_answer} para alcanzar el puntaje mínimo para aprobar. Necesitará obtener {minimum_score} de {qty_questions} preguntas para aprobar esta prueba.",
    you_can_take_this_test_up_to_times_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test: "Puede realizar esta prueba hasta {maximum_attempts} veces para lograr el puntaje mínimo para aprobar. Necesitará obtener {minimum_score} de {qty_questions} preguntas para aprobar esta prueba.",
    you_got_out_of_questions_right_success_rate_and_you_showed_that_you_understand_a_lot_keep_it_up_and_show_that_you_are_the_one_who_dominates_this_subject: "¡Recibió {score} de {questions} preguntas ({percent}%) y demostró que comprende mucho! ¡Sigue así y demuestra que eres tú quien domina este tema!",
    you_got_out_of_questions_successful_and_you_didnt_reach_the_minimum_score_to_pass: "Llegaste a {score} de {questions} ({percent}% de logro) y no alcanzaste la calificación mínima para aprobar ({minimum_score}% de logro).",
    you_did_not_reach_the_minimum_score_to_pass_try_again_to_complete_the_course: "No alcanzaste la calificación mínima para aprobar. ¡Intenta nuevamente para completar el curso!",
    you_did_not_reach_the_minimum_score_to_pass: "No alcanzaste la calificación mínima para aprobar.",
    you_got_out_of_success: "Obtuviste {score} de {questions} ({percent}% de éxito).",
    you_have_already_answered_this_test_times_and_have_attempt_left: "Ya ha completado esta prueba {qty_attempted} veces y le quedan {attempts_left}.",
    you_have_been_blocked_in_this_course_and_will_not_receive_a_certificate: "Has sido bloqueado en este curso y no recibirás un certificado",
    you_have_been_blocked_in_this_training_and_will_not_receive_a_certificate_you_can_still_finish_the_other_available_activities: "Ha sido bloqueado en esta capacitación y no recibirá un certificado. Todavía puede terminar las otras actividades disponibles.",
    you_have_been_blocked: "Has sido bloqueado",
    you_have_only_one_attempt_to_pass_and_will_be_blocked_from_this_training_if_you_fail: "Solo tienes un intento de pasar y serás bloqueado de este entrenamiento si fallas.",
    you_have_only_one_attempt_to_pass_and_will_have_your_progress_restarted_in_this_training_if_you_fail: "Solo tiene un intento de pasar y se reiniciará su progreso en este entrenamiento si falla.",
    you_need_to_enroll_before_starting_this_content: "Debes inscribirte antes de comenzar este contenido",
    you_need_to_enroll_before_starting_this_course: "Necesitas registrarte antes de comenzar este curso",
    you_need_to_finish_another_course_before_starting_this: "Necesitas terminar otro curso antes de comenzar este",
    you_need_to_get_of_questions_right_to_be_approved: "Debe obtener {minimum_score} de {qty_questions} preguntas para aprobar esta prueba.",
    your_progress_has_been_restarted_and_you_will_need_to_redo_all_activities_in_this_training_to_receive_the_certificate: "Su progreso se ha reiniciado y deberá volver a realizar todas las actividades de esta capacitación para recibir el certificado.",
    your_progress_has_been_restarted: "Tu progreso ha sido reiniciado",
    you_have_been_reproved_and_reached_the_maximum_attempts_restart_training: "Has sido reprobado y alcanzaste el número máximo de intentos sin aprobación. Tu entrenamiento ha sido reiniciado, rehaz todas las actividades anteriores para intentar nuevamente.",
    your_result: "Tu resultado",
    your_status: "Tu estado",
    training_in_progress: 'Curso siendo desarrollado por el gestor',
    video_issue_ios_message: '¿Tienes problemas para ver el video? ¡No te preocupes! Toca el botón de abajo para abrirlo en el navegador de tu celular.',
    watch_in_browser: 'Ver en el navegador',
}
